<template>
    <div class="rectangle-shape">
        <h3>{{ meta.data.title }}</h3>
        <p>Meta: {{ JSON.stringify(meta) }}</p>
    </div>
</template>

<script>
export default {
    name: 'rectangle-shape',
    props: ['meta'],
}
</script>

<style lang="scss">
.rectangle-shape {
}
</style>
